import { render, staticRenderFns } from "./ConfigurableSettingView.vue?vue&type=template&id=40f681e4&scoped=true"
import script from "./ConfigurableSettingView.ts?vue&type=script&lang=ts&external"
export * from "./ConfigurableSettingView.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f681e4",
  null
  
)

export default component.exports